/**
 * Sidebar
 */

// Bootstrap tooltips
$('[data-toggle="tooltip"]').tooltip();

// Bootstrap popovers
$('[data-toggle="popover"]').popover();

// Init Slick
$('.slideshow').slick({
  autoplay: true,
  dots: true,
  infinite: true,
  speed: 500,
});

// Init Slick
$('.carousel').slick({
  dots: true,
  infinite: true,
  speed: 300,
  slidesToShow: 3,
  slidesToScroll: 3,
  responsive: [
    {
      breakpoint: 1024,
      settings: {
        slidesToShow: 3,
        slidesToScroll: 3,
      },
    },
    {
      breakpoint: 600,
      settings: {
        slidesToShow: 2,
        slidesToScroll: 2,
      },
    },
    {
      breakpoint: 480,
      settings: {
        slidesToShow: 2,
        slidesToScroll: 2,
      },
    },
  ],
});

// Init Fancybox
$('.fancybox').fancybox({
  helpers: {
    overlay: {
      locked: false, // Prevent page from jumping back to top
    },
  },
});



// WEBPACK FOOTER //
// ./assets/js/components/utilities.js